<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
    import ShutterNotes from "@/mixins/shutters-manager/Notes.js"

    export default {
        name: "NoteListe",
        mixins: [ShutterNotes],
        props: ['horse_id', 'tiers_id'],
		mounted() {
            if(this.horse_id){
                this.setupHorseNotesList(this.horse_id)
            } else if (this.tiers_id){
                this.setupTierNotesList(this.tiers_id)
            } else {
                this.setupNotesList()
            }
		},
    }
</script>
